import React, {RefObject, createRef} from 'react';
import {SelectCompanyDlg} from './SelectCompanyDlg';

export const selectCompanyDlgRef: RefObject<typeof SelectCompanyDlg> = createRef();
export const renderCompanyDlg = root => {
    root.render(<SelectCompanyDlg />);
    return selectCompanyDlgRef;
};
